import TenIcon from '../icon';

const ICON_TYPE_MAP = {
  error: 'circle_clear',
  success: 'circle_tick',
  warning: 'circle_error',
  info: 'circle_info',
};

export default {
  components: {
    TenIcon,
  },
  props: {
    /**
     * 消息类型
     *
     * @member success | info | warning | error
     */
    type: {
      type: String,
      validator(v) {
        return ['success', 'info', 'warning', 'error'].indexOf(v) > -1;
      },
    },
    /**
     * 显示关闭按钮
     */
    showClose: { type: Boolean, default: true },
    /**
     * 显示时长，单位ms
     */
    duration: { type: Number, default: 4500 },
    /**
     * 标题
     *
     * @member String | Function(JSX)
     */
    title: [String, Function],
    /**
     * 内容
     *
     * @member String | Function(JSX)
     */
    message: [String, Function],
    /**
     * 自定义弹出位置
     *
     * @member top-right | top-left | bottom-right | bottom-left
     */
    position: {
      type: String,
      validator(v) {
        return ['top-right', 'top-left', 'bottom-right', 'bottom-left'].indexOf(v) > -1;
      },
      default: 'top-right',
    },
    /**
     * 自定义类
     */
    customClass: String,
    /**
     * 关闭按钮回掉
     */
    onClose: Function,
  },
  data() {
    return {
      timer: null,
      closed: false,
      visible: false,
    };
  },
  computed: {
    className() {
      return [
        'ten-notification',
        this.customClass,
        {
          'ten-notification--success': this.type === 'success',
          'ten-notification--error': this.type === 'error',
          'ten-notification--info': this.type === 'info',
          'ten-notification--warning': this.type === 'warning',
        },
      ];
    },
    horizontalClass() {
      return this.position.indexOf('right') > -1 ? 'right' : 'left';
    },
    iconType() {
      return this.icon || ICON_TYPE_MAP[this.type];
    },
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('animationend', this.destroyElement);
      }
    },
  },
  mounted() {
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.close();
        }
      }, this.duration);
    }
  },
  render() {
    let { message, title } = this;
    if (typeof message === 'function') message = message();
    if (typeof title === 'function') title = title();

    return (
      <transition appear name="ten-notification-fade">
        <div
          v-show={this.visible}
          class={['ten-notification', this.horizontalClass]}
          onMouseenter={this.clearTimer}
          onMouseleave={this.startTimer}
        >
          {this.type && (
            <ten-icon
              class={['ten-notification_icon', this.type]}
              icon={this.iconType}
            />
          )}
          <div class="ten-notification_content">
            <div class="ten-notification_title">
              {title}
            </div>
            <div class="ten-notification_message">
              {message}
            </div>
          </div>
          {this.showClose && (
            <div class="ten-notification_closeBtn" onClick={this.close}>
              <ten-icon icon="clear" />
            </div>
          )}
        </div>
      </transition>
    );
  },
  methods: {
    close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    clearTimer() {
      this.timer && clearTimeout(this.timer);
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
    destroyElement() {
      this.$el.removeEventListener('animationend', this.destroyElement);
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
  },
};
